import gql from 'graphql-tag';

import { clients } from '../../../util/clients';
import { fieldsToGqlString } from '../../../util/shared/vue-global';

const { backend } = clients.direct;
const logHistoryFields = {
  _id: '',
  logDate: '',
  type: '',
  amount: '',
};

const bidderRegistrationFields = {
  _id: '',
  regNumber: '',
  bidderName: '',
  addressOne: '',
  addressTwo: '',
  city: '',
  state: '',
  zipCode: '',
  phoneNumber: '',
  emailAddress: '',
  logHistory: {
    ...logHistoryFields,
  },
};

export const bidderRegistration = {
  async bidderRegistration({ commit, dispatch }, { criteria, baseCrudKey, postProcessTrans }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.query({
        query: gql`
            query bidderRegistration($criteria: bidderRegistrationCriteriaType) {
              bidderRegistration(criteria: $criteria) {
                ${fieldsToGqlString(bidderRegistrationFields)},
              }
            }
          `,
        variables: { criteria },
        fetchPolicy: 'no-cache',
      });
      clients.handleGQLErrors(results, commit);
      if (baseCrudKey && results.data) {
        const processedData = postProcessTrans
          ? postProcessTrans(results.data.bidderRegistration)
            || [] : results.data.bidderRegistration;
        commit('base/crud/setItems', [baseCrudKey, processedData], { root: true });
        return processedData;
      }
    } catch (e) {
      dispatch('logException', e, { root: true });
      clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem getting tax bidder registration.', { root: true });
    }
    return [];
  },
  async upsertBidderRegistration({ dispatch, commit },
    { item }) {
    let results;

    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation upsertBidderRegistration($item:bidderRegistrationInputType) {
            upsertBidderRegistration(upsert:$item) {
              statusCode, _id
            }
          }`,
        variables: {
          item,
        },
      });

      clients.handleGQLErrors(results, commit);
      const { upsertBidderRegistration } = results.data;
      if (upsertBidderRegistration.statusCode === 200) dispatch('flashSuccess', 'Bidder registration upserted successfully', { root: true });
      else if (upsertBidderRegistration.statusCode === 202) dispatch('flashError', 'Reg # is already exits, please add another Req #', { root: true });
      else dispatch('flashError', 'There was a problem in upserting the bidder registration upsert', { root: true });
      return upsertBidderRegistration;
    } catch (error) {
      dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem in upserting the bidder registration upsert', { root: true });
    }
    return {};
  },
  async bidderRegistrationLogUpdate({ dispatch, commit },
    { item }) {
    let results;

    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation bidderRegistrationLogUpdate($item:bidderRegistrationLogUpdateInputType) {
            bidderRegistrationLogUpdate(upsert:$item) {
              statusCode
            }
          }`,
        variables: {
          item,
        },
      });

      clients.handleGQLErrors(results, commit);
      const { bidderRegistrationLogUpdate } = results.data;
      if (bidderRegistrationLogUpdate.statusCode === 200) dispatch('flashSuccess', 'Bidder registration log updated successfully', { root: true });
      else dispatch('flashError', 'There was a problem in updating the bidder registration log', { root: true });
      return bidderRegistrationLogUpdate;
    } catch (error) {
      dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem in updating the bidder registration log', { root: true });
    }
    return {};
  },
  async updateBidderRegistrationLogAndRecalculateBalance({ dispatch, commit },
    { item }) {
    let results;

    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation updateBidderRegistrationLogAndRecalculateBalance($item:bidderRegistrationLogUpdateInputType) {
            updateBidderRegistrationLogAndRecalculateBalance(upsert:$item) {
              statusCode
            }
          }`,
        variables: {
          item,
        },
      });

      clients.handleGQLErrors(results, commit);
      const { updateBidderRegistrationLogAndRecalculateBalance } = results.data;
      if (updateBidderRegistrationLogAndRecalculateBalance.statusCode === 200) dispatch('flashSuccess', 'Bidder registration log updated and balance recalculated successfully', { root: true });
      else dispatch('flashError', 'There was a problem in updating the bidder registration log and recalculating the balance', { root: true });
      return updateBidderRegistrationLogAndRecalculateBalance;
    } catch (error) {
      dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem in updating the bidder registration log and recalculating the balance', { root: true });
    }
    return {};
  },
  async clearBidderList({ dispatch, commit }) {
    let results;

    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation clearBidderList {
            clearBidderList {
              statusCode
            }
          }`,
      });

      clients.handleGQLErrors(results, commit);
      const { clearBidderList } = results.data;
      if (clearBidderList.statusCode === 200) dispatch('flashSuccess', 'Bidder registration deleted successfully', { root: true });
      else dispatch('flashError', 'There was a problem in deleting the bidder registration', { root: true });
      return clearBidderList;
    } catch (error) {
      dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem in deleting the bidder registration', { root: true });
    }
    return {};
  },
  async deleteBidderRegistration({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
    let results;
    try {
      await dispatch('reAuth', null, { root: true });
      results = await backend.mutate({
        mutation: gql`mutation deleteBidderRegistration ($id: ID!)  {
                deleteBidderRegistration(id: $id) {
                      _id
                    }
                  }`,
        variables: {
          id: item._id,
        },
      });
      clients.handleGQLErrors(results, commit);
      const delId = results.data.deleteBidderRegistration._id;
      const taxData = rootGetters['base/crud/items'](baseCrudKey);
      const updatedData = taxData.filter((d) => d._id !== delId);
      commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
      commit('base/crud/setIsVisible', [baseCrudKey, false], { root: true });
    } catch (e) {
      dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
      dispatch('flashError', 'There was a problem deleting the Bidder Registration', { root: true });
    }
  },
};

export default bidderRegistration;
